export function isPricePending(product) {
  return product?.price_status === "pending" || product?.price === null || product?.price === undefined ||
    product?.price === "" || !Number.isFinite(Number(product.price)) || Number(product.price) <= 0;
}

export function canPurchase(product) {
  return !isPricePending(product) && !isOutOfStock(product);
}

export function isOutOfStock(product) {
  if (product?.stockStatus === "out_of_stock") return true;
  return [product?.stock, product?.stock_quantity].some((value) =>
    value !== null && value !== undefined && value !== "" &&
    Number.isFinite(Number(value)) && Number(value) <= 0
  );
}
export function schemaAvailability(product) {
  return isOutOfStock(product) ? "https://schema.org/OutOfStock" : "https://schema.org/InStock";
}
